(ns teamoesterreich.util.ws
  (:require
    [teamoesterreich.util.log :as log :include-macros true]
    [cljs.core.async :as async :refer [put! timeout <! chan]])
  (:require-macros [cljs.core.async.macros :refer [go go-loop]]))


;(str (aget js/location "hostname"))  ;; treat it as an array
;(aset js/location "myval" "theval")

;(str (.-hostname js/location))  ;; treat it like a function or property (not working minified)
;(set! (.-myval js/location) "theval")

(let [!open (atom true)]
  (defn ws-loop [uri >data-ch >state-ch <ctl-ch <send-ch]
    (let [ws (js/WebSocket. uri)]

      (go-loop []
               (let [payl (<! <send-ch)]
                 ;(log/debug "send to channel:" payl)
                 (.send ws payl))
               (recur))

      (go (let [res (<! <ctl-ch)]
            (reset! !open false)
            (log/debug "ws turned off (" @!open ")")
            (.close ws)))
      (set!
        (.-onmessage ws)
        (fn[e]
          (put! >data-ch e)))
      (set!
        (.-onclose ws)
        (fn[e]
          (put! >state-ch :closed)
          (go
            (<!(timeout 100))
            (log/debug "ws reconnect " @!open)
            (when @!open
              (ws-loop uri >data-ch >state-ch <ctl-ch <send-ch)))))
      (set!
        (.-onopen ws)
        (fn [e]
          (put! >state-ch :opened)))))

  )
